import React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Typography } from '@mui/material';
import { useFetchLang } from '../../hooks/fetchs-site';
import  PropTypes from 'prop-types';


function findLAngTitle(array, id) {
    if(array){
        return array.find((element) => {
            return element.id === id;
        })
    }
    return array
}

export default function SelectLang({onChange, selectedValue}) {
    // const { setAuthLang, authDataLang } = useAuth();
    // const [age, setAge] = useState('');
    const [ dataLang, langLoading, langError ] = useFetchLang('');
    
    const handleChange = (event) => {
        onChange(event.target.value);
    };

  return (
        <Box sx={{ minWidth: 200 }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h6"
                        >
                        زبان
                    </Typography>
                </InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={findLAngTitle(dataLang, selectedValue)}
                    label={(
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            >
                            زبان را انتخاب کنید
                        </Typography>
                    )}
                    options={dataLang}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    onChange={handleChange}
                    >
                    {dataLang && dataLang.map(lang => {
                        return <MenuItem key={lang.id} value={lang}>{lang.title}</MenuItem>
                    })}
                    
                </Select>
            </FormControl>
        </Box>
  );
}


SelectLang.propTypes = {
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
};